<template>
	<div class="clock-select-view edit" @click.stop="toggle($event)" :value="value" @input="$emit('input')">
		<div class="edit__label">{{ label }} <span v-if="!optional && label">*</span></div>
		<input type="text" :value="_value" disabled>
	</div>
</template>

<script>
	import ClockPopupView from './ClockPopupView'

	export default {
		props: {
			value: {
				type: [String, Number]
			},
			controller: {
				
			},
			label: {
				type: String
			},
			optional: {
				type: Boolean
			}
		},
		computed: {
			_value() {
				return isNaN(this.value) ? this.$options.filters.time(this.value) : this.$options.filters.duration(this.value);
			}
		},
		watch: {
			value() {
				console.log('ksdjfhgiks');
				console.log(this.controller.getPopupView());
				this.controller.getPopupView().value = this.value;
			}
		},
		methods: {
			input(value) {
				this.$emit('input', value);
			},
			toggle(event) {
				console.log(this.value);

				this.controller.toggle(ClockPopupView, {
					anchor: event.currentTarget,
					value: this.value,
					owner: this
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.clock-select-view {
		& > input {
			cursor: pointer;
		}

		&.gray {
			& > input {
				background-color: rgb(231, 231, 231);
				color: black;
			}
		}
	}
</style>